// Generated by CoffeeScript 1.12.7
var evaluateType, getPath;

evaluateType = require('./evaluate-type');

getPath = require('./get-path');

module.exports = function(findModule) {
  return function(di, base, modules, callers) {
    Object.keys(modules).forEach(function(key) {
      var instance, mod, path, type;
      mod = modules[key];
      path = getPath(mod);
      instance = findModule(base, path, callers);
      type = evaluateType(mod, instance);
      return di[type](key, instance);
    });
    return di;
  };
};
